export default {
    formatTags(value) {
        if (value && value.length) {
            return value.map(item => item.name).join(', ');
        }
        return '';
    }
};
